import { render, staticRenderFns } from "./cadclientes.vue?vue&type=template&id=30719670&"
import script from "./cadclientes.vue?vue&type=script&lang=js&"
export * from "./cadclientes.vue?vue&type=script&lang=js&"
import style0 from "./cadclientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports